import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { PeopleDefaultColumnFields } from './use-static-column-fields';

export const columnOrder = [
  PeopleDefaultColumnFields.Name,
  'title',
  'jobLevel',
  'influence',
  'sentiment',
  PeopleDefaultColumnFields.LastEngagedOn,
  PeopleDefaultColumnFields.RecentRisks,
  PeopleDefaultColumnFields.RecentOpportunities,
];

export const sortFieldsInColumnOrder = (fields: FilterableField[]) => {
  return fields.slice().sort((a, b) => {
    const aIndex = columnOrder.findIndex(
      (field) => field === a.fieldName || a.fieldName.startsWith(`${field}`),
    );
    const bIndex = columnOrder.findIndex(
      (field) => field === b.fieldName || b.fieldName.startsWith(`${field}`),
    );

    const aInOrder = aIndex !== -1;
    const bInOrder = bIndex !== -1;

    if (aInOrder && bInOrder) {
      return aIndex - bIndex;
    }
    if (aInOrder) {
      return -1;
    }
    if (bInOrder) {
      return 1;
    }
    const aLabel = a.fieldLabel || a.fieldName;
    const bLabel = b.fieldLabel || b.fieldName;

    return aLabel.localeCompare(bLabel, undefined, { sensitivity: 'base' });
  });
};
